import _collections from './collections_from_sheet.json'

export const collections = _collections

const collections_: Collection[] = [
  {
    id: 'altglas',
    name_de: 'Altglas',
    icon: 'm24.84,16.4v19.99c0,1.04-2.5,1.87-5.59,1.87s-5.59-.84-5.59-1.87v-19.99c0-5.88,3.25-6.67,3.25-14.32-.37-.16-.59-.37-.59-.59v-.51C16.31.44,17.63,0,19.24,0s2.93.44,2.93.98v.51c0,.22-.22.43-.59.59,0,7.64,3.25,8.44,3.25,14.32Z',
  },
  {
    id: 'pet',
    name_de: 'PET',
    icon: 'm12.96,37.99h12.57c.69,0,1.26-.57,1.26-1.26v-6.93c0-.69-.57-1.26-1.26-1.26.69,0,1.26-.57,1.26-1.26v-1.78c0-.69-.57-1.26-1.26-1.26.69,0,1.26-.57,1.26-1.26v-1.79c0-.69-.57-1.26-1.26-1.26.69,0,1.26-.57,1.26-1.26v-1.78c0-.57-.39-1.05-.91-1.2.52-.16.91-.63.91-1.2v-1.1c0-2.36-1.37-4.58-3.69-5.98l-.53-.57c-.39-.43-.72-1.15-.82-1.75h-5.01c-.1.6-.43,1.32-.82,1.75l-.53.57c-2.32,1.4-3.69,3.62-3.69,5.98v1.1c0,.57.39,1.05.91,1.2-.52.15-.91.63-.91,1.2v1.78c0,.69.57,1.26,1.26,1.26-.69,0-1.26.57-1.26,1.26v1.79c0,.69.57,1.26,1.26,1.26-.69,0-1.26.57-1.26,1.26v1.78c0,.69.57,1.26,1.26,1.26-.69,0-1.26.57-1.26,1.26v6.93c0,.69.57,1.26,1.26,1.26h0ZM15.73.28h7.04v3.56h-7.04V.28Z',
  },
  {
    id: 'sonderabfall',
    name_de: 'Sonderabfall',
    icon: 'm15.12,20.25c0-.9.73-1.64,1.64-1.64s1.64.73,1.64,1.64-.73,1.64-1.64,1.64-1.64-.73-1.64-1.64Zm6.82,1.64c.9,0,1.64-.73,1.64-1.64s-.73-1.64-1.64-1.64-1.64.73-1.64,1.64.73,1.64,1.64,1.64Zm-3.13,2.56h1.21c.12,0,.21-.1.21-.21v-.86c0-.45-.37-.81-.81-.81s-.81.37-.81.81c0,.03,0,.86,0,.86,0,.06.02.11.06.15.04.04.1.06.15.06ZM5.45,7.67h27.59l-2.9,27.36H8.35L5.45,7.67Zm9.26,17.25c.34.32.53.78.53,1.27v1.13c0,.47.38.85.85.85h6.54c.47,0,.85-.38.85-.85v-1.13c0-.49.19-.95.53-1.27,1.35-1.29,2.1-3.02,2.1-4.89s-.78-3.66-2.15-4.94c-1.26-1.18-2.88-1.82-4.6-1.82-.16,0-.32,0-.48.02-3.36.23-6.06,2.95-6.26,6.32-.12,2,.64,3.93,2.09,5.31ZM5.45,3.24v3.27h27.59v-3.27H5.45Z',
  },
  {
    id: 'gruengut',
    name_de: 'Grüngut',
    icon: 'm34.62,14.09c-.17-.17-.41-.27-.65-.25l-5.84.34c-2.91.17-5.14,2.67-4.97,5.58,0,.08.01.15.02.23l.2,2.1c.12,1.17-.3,2.34-1.13,3.17-.04.04-.08.09-.12.14-.75.84-1.41,1.77-1.95,2.76v-9.68c0-1.18.54-2.3,1.46-3.04l1.64-1.34c1.23-1.01,1.95-2.52,1.95-4.11-.01-1.29-.5-2.53-1.37-3.48l-3.89-4.38c-.34-.35-.89-.36-1.25-.02,0,0-.02.02-.02.02l-3.89,4.38c-.86.96-1.33,2.2-1.33,3.49,0,1.59.71,3.1,1.95,4.11l1.64,1.34c.92.74,1.46,1.86,1.46,3.04v10.01c-.6-1.12-1.34-2.16-2.2-3.1-.03-.05-.07-.1-.12-.14-.83-.84-1.23-2-1.11-3.17l.2-2.1c.29-2.9-1.83-5.49-4.73-5.78-.07,0-.14-.01-.21-.02l-5.84-.34c-.47-.02-.87.34-.9.81,0,.03,0,.06,0,.09l.34,5.84c.17,2.91,2.67,5.14,5.58,4.97.07,0,.14,0,.21-.02l2.11-.2c1.11-.11,2.21.26,3.03,1.01,2.26,2.39,3.51,5.55,3.5,8.84v.46c.07.49.52.84,1.01.77.43-.06.75-.41.78-.84v-1.89c.31-2.75,1.51-5.33,3.41-7.34.82-.75,1.92-1.12,3.03-1.01l2.11.2c2.9.3,5.5-1.81,5.8-4.71,0-.07.01-.13.02-.2l.34-5.84c.03-.25-.06-.51-.25-.69Z',
  },
  {
    id: 'karton',
    name_de: 'Karton',
    icon: 'm7.57,12.91h23.36v7.96H7.57v-7.96Zm0-.86h23.36s-1.71-7.96-1.71-7.96H9.28s-1.71,7.96-1.71,7.96Zm-.86.86L0,10.77v7.96s6.71,2.14,6.71,2.14v-7.96Zm31.78-2.14l-6.71,2.14v7.96s6.71-2.14,6.71-2.14v-7.96Zm-29.64,23.41h20.79s1.28-12.45,1.28-12.45H7.57s1.28,12.45,1.28,12.45Z',
  },
  {
    id: 'papier',
    name_de: 'Papier',
    icon: 'm33.79,29.94H4.7c-.37,0-.68-.3-.68-.67s.3-.67.68-.67h29.09c.37,0,.68.3.68.67s-.3.67-.68.67Zm.68-3.57c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Zm0-2.9c0-.37-.3-.67-.68-.67H4.7c-.37,0-.68.3-.68.67s.3.67.68.67h29.09c.37,0,.68-.3.68-.67Z',
  },
  {
    id: 'textile',
    name_de: 'Schuhe und Textilien',
    icon: 'm34.13,9.24l-1.03,6.37h-4.6v16.73c0,.22-.18.4-.4.4H10.38c-.22,0-.4-.18-.4-.4V15.61h-4.59l-1.03-6.37,9.69-3.71c1.04,1.8,2.97,3.01,5.2,3.01s4.16-1.21,5.2-3.01l9.69,3.71Z',
  },
  {
    id: 'plastic',
    name_de: 'Kunststoff',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
  {
    id: 'special',
    name_de: 'Spezial',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
  {
    id: 'rest',
    name_de: 'Kehricht',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
  {
    id: 'separate',
    name_de: 'Weiter Trennen',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
  {
    id: 'alu',
    name_de: 'Alu',
    icon: 'm27.08,36.77h-15.67l-1.13-1.89h17.93l-1.13,1.89ZM11.05,2.12c0,.35.28.63.63.63h15.12c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-15.12c-.35,0-.63.28-.63.63Zm-.96,6.93h18.3l-2.02-5.04h-14.27l-2.02,5.04Zm-.3,24.57h18.9V10.31H9.79v23.31Z',
  },
  {
    id: 'metall',
    name_de: 'Weiss- und Stahlblech',
    icon: 'm29.94,3.95v7.8H8.54V3.95h21.39Zm0,14.31v1.81H8.54v-1.81h21.39Zm-21.39-.96v-1.81h21.39v1.81H8.54Zm21.39,3.73v1.81H8.54v-1.81h21.39Zm0-6.5H8.54v-1.81h21.39v1.81Zm-21.39,9.28h21.39v1.81H8.54v-1.81Zm0,2.77h21.39v7.75H8.54v-7.75Zm22.29,10.48c0,.19-.16.35-.35.35H8c-.19,0-.35-.16-.35-.35v-1.42c0-.19.16-.35.35-.35h22.48c.19,0,.35.16.35.35v1.42ZM7.65,1.21c0-.19.16-.35.35-.35h22.48c.19,0,.35.16.35.35v1.42c0,.19-.16.35-.35.35H8c-.19,0-.35-.16-.35-.35v-1.42Z',
  },
  {
    id: 'bury',
    name_de: 'Im Garten vergraben',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
  {
    id: 'toilett',
    name_de: 'In der Toilette entsorgen',
    icon: 'm31.36,31.24H7.13V7.02h24.22v24.22Z',
  },
]

export const collectionsmap: { [key: string]: Collection } = collections.reduce(
  (acc: any, item) => {
    acc[item.id] = item
    return acc
  },
  {}
)
